import React, {useEffect, useState} from 'react';
import ModalHeader from '../presentations/ModalHeader';
import Repository, {UpdateUserRepositoryInterface} from '../services/repository';
import {useForm} from 'react-hook-form';
import UserProfileLayout from '../presentations/UserProfileLyaout';
import ModalFooter from '../presentations/ModalFooter';
import Button from '../presentations/Button';
import Spinner2 from '../presentations/Spinner2';
import ModalBody from '../presentations/ModalBody';
import {ApiError, ApiResponse} from '../services/api';
import {UserType} from '../stores/authenticated';
import Padding from '../presentations/Padding';
import AlertApiErrorMessage from '../presentations/AlertApiErrorMessage';
import UserProfileManagerFormFieldset from '../presentations/UserProfileManagerFormFieldset';
import {set as setRoles, RoleType} from '../stores/roles';
import store from '../stores';

interface UpdateUserProfileInterface {
  user: UserType
  onClose: () => void
}

interface UpdateUserProfileFormInterface {
  username: string
  firstName: string
  lastName: string
  departmentId: number
  role: string
  email: string
  password: string
  phone: string
}

const UserProfileUpdater: React.FC<UpdateUserProfileInterface> = (props) => {
  const repository                       = new Repository();
  const [sending, setSending]            = useState<boolean>(false);
  const [alertMessage, setAlertMessage]  = useState<React.ReactElement | null>(null);
  const {register, handleSubmit, errors, setValue, getValues} = useForm<UpdateUserProfileFormInterface>({
    defaultValues: {
      username    : props.user.username,
      firstName   : props.user.firstName,
      lastName    : props.user.lastName,
      departmentId: props.user.department.id,
      role        : props.user.roles[0].name,
      email       : props.user.email,
      password    : '',
      phone       : props.user.phone,
    }
  });

  const isRequiredName = (value: any) => {
    const values = getValues();
    return !!values.firstName || !!values.lastName;
  }

  const registerSetting = {
    username    : {required: true},
    firstName   : {validate: isRequiredName},
    lastName    : {validate: isRequiredName},
    departmentId: {required: true},
    role        : {required: true},
    email       : {required: true},
    password    : {required: false},
    phone       : {required: false},
  }

  useEffect(() => {
    repository.getRoles()
            .then(({data}: ApiResponse<RoleType[]>) => {
              store.dispatch(setRoles(data));
              setValue('role', props.user.roles[0].name);
            });
  }, []);

  const onSubmit = (formValue: UpdateUserProfileFormInterface) => {
    const post: any   = formValue;
    post.departmentId = Number(post.departmentId);
    post.roles = [post.role];
    delete post.role;

    if (!post.password) {
      delete post.password
    }

    setSending(true);

    console.log(post);

    repository.updateUser(props.user.id as number, post as UpdateUserRepositoryInterface)
            .then(() => {
              props.onClose();
            })
            .catch(({response}: ApiError) => {
              console.log(response);
              setSending(false);
              setAlertMessage(<AlertApiErrorMessage response={response} title={<p>更新に失敗しました。</p>}/>);

            })
            .finally(() => {
            });
  }

  const column2 = <UserProfileManagerFormFieldset register={register} registerSetting={registerSetting}
                                                  errors={errors}/>;

  return (
          <form noValidate method={'post'} onSubmit={handleSubmit(onSubmit)}>
            <ModalHeader><h3>ユーザーを編集</h3></ModalHeader>
            <ModalBody>
              <Padding padding={'30px 40px 40px'}>
                <>
                  {alertMessage}
                  <UserProfileLayout column2={column2}/>
                </>
              </Padding>
            </ModalBody>
            <ModalFooter>
              <Button type={'button'} width={'130px'} margin={'0 10px 0 0'} fontSize={12} onClick={props.onClose}>
                キャンセル
              </Button>
              <Button type={'submit'} color={'secondary'} width={'130px'} fontSize={12} disabled={sending}>
                {sending ? <Spinner2/> : null} 更新
              </Button>
            </ModalFooter>
          </form>
  );
}

export default UserProfileUpdater;
